import { Button } from '@web-chat-core/ui-kit';
import { JoinCallButton } from 'ui/components/Button';
import { ApprovalRetryButton } from '../view';
import { BrandRetryButton } from '../brandWaitingView';

type WaitingApprovalRejectActionsProps = {
    variant: 'lottie' | 'brand';
    retryLabel: string;
    dismissLabel: string;
    onRetry: () => void;
    onDismiss?: () => void;
};

export const WaitingApprovalRejectActions = ({
    variant,
    retryLabel,
    dismissLabel,
    onRetry,
    onDismiss,
}: WaitingApprovalRejectActionsProps) => {
    if (variant === 'lottie') {
        return (
            <>
                <ApprovalRetryButton onClick={onRetry}>{retryLabel}</ApprovalRetryButton>
                {onDismiss && <JoinCallButton onClick={onDismiss}>{dismissLabel}</JoinCallButton>}
            </>
        );
    }

    return (
        <>
            <BrandRetryButton onClick={onRetry}>{retryLabel}</BrandRetryButton>
            {onDismiss && <Button onClick={onDismiss}>{dismissLabel}</Button>}
        </>
    );
};
